import { Reports } from '../internal/errors/reports.client';
export default Reports;

//# sourceMappingURL=reports.js.map